//队列管理
module.exports = function queue(worker){
  var currentCallback = null;
  return {
    timeout: null,
    running : false,
    tasks: [],
    push: function(data, cb){
      var callback = cb || function(){};
      var self = this;
      this.tasks.push({
        data: data,
        callback: callback
      });
      //当任务被放入队列后马上调用process处理，在process中如果running:false就可以立马运行
      setTimeout(function(){
        self.process();
      }, 0);
    },
    dequeue: function(){
      if(currentCallback){
        currentCallback();
      }else{
        this.running = false;
      }
    },
    process: function(){
      var self = this;
      if(this.tasks.length && !this.running){
        var task = self.tasks.shift();
        self.running = true;
        currentCallback = function(){
          self.running = false;
          task.callback(task.data);
          self.process();
        };
        worker(task.data, currentCallback);
      }
    }
  };
};


// WEBPACK FOOTER //
// ./~/@dp/knb/compiled/titans/util/queue.js